import { useNotification } from "@/utils/notification";
import { defineStore } from "pinia";
import { Ref, ref } from "vue";
import { providerService } from "@/features/providers/providers.service";

const { pushNotification } = useNotification();

export const useProvidersStore = defineStore("providers", () => {
  async function getProviders(loading: Ref<boolean>) {
    try {
      loading.value = true;
      const { data } = await providerService.getProviders();
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return [];
    } finally {
      loading.value = false;
    }
  }

  return {
    getProviders,
  };
});
